import React from 'react';

interface WelcomeModalProps {
  isOpen: boolean;
  displayName: string;
  email: string;
  provider: string;
  onClose: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({
  isOpen,
  displayName,
  email,
  provider,
  onClose
}) => {
  if (!isOpen) return null;

  const providerNames: Record<string, string> = {
    google: 'Google',
    apple: 'Apple',
    github: 'GitHub',
  };

  const providerName = providerNames[provider.toLowerCase()] || provider;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        <div className="text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
            <svg
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          {/* Welcome Message */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Welcome to Fawayo!
          </h2>

          <p className="text-gray-600 mb-6">
            Your account has been created successfully using {providerName}.
          </p>

          {/* User Info */}
          <div className="bg-gray-50 rounded-md p-4 mb-6 text-left">
            <div className="mb-2">
              <span className="text-sm font-medium text-gray-700">Name:</span>
              <p className="text-gray-900">{displayName}</p>
            </div>
            <div>
              <span className="text-sm font-medium text-gray-700">Email:</span>
              <p className="text-gray-900">{email}</p>
            </div>
          </div>

          {/* Continue Button */}
          <button
            onClick={onClose}
            className="w-full bg-primary-600 text-white py-3 px-4 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-colors"
          >
            Continue to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
